import React from "react";
import { useAuth } from "@context/auth-context";
import { subscriptionRequiredAlert } from "@util/alert";
import Button from "../Button/Button";
import styles from "./AvailableWithPlatformAccessButton.module.css";

const AvailableWithPlatformAccessButton: React.FC = () => {
    const { authState } = useAuth();
    const { user } = authState;

    const isBusinessAdmin = user?.userType === "business_admin";

    const handleClick = () => {
        if (!isBusinessAdmin) {
            subscriptionRequiredAlert();
        }
    };

    return (
        <div className={styles.subscribeBtnContainer}>
            <Button
                variant="submit"
                size="medium"
                {...(isBusinessAdmin
                    ? { to: "/account/subscribe" }
                    : { onClick: handleClick })}
            >
                Available with Platform Access
            </Button>
        </div>
    );
};

export default AvailableWithPlatformAccessButton;